import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { ContentStrapiService } from 'src/app/services/content-strapi/content-strapi.service';
import { ContentService } from 'src/app/services/content/content.service';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { RouterService } from 'src/app/services/router/router.service';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent implements OnInit {
  slidesContentPerView : number = 1;
  slideOpts:{};
  sliders: any;
  images: any = [];

  constructor(private languageService: LanguagesService,
    public platform : Platform,
    private contentService: ContentService,
    private contentStrapiService: ContentStrapiService,
    private routerService: RouterService) {
  }

  ngOnInit() {
    this.getSliderHome();
    if(this.platform.is("desktop")){
      this.slidesContentPerView = 1;
    }
    this.slideOpts = {
      initialSlide: 0,
      spaceBetween: 1,
      speed: 200,
      slidesPerView: this.slidesContentPerView,
      autoplay: true,
      loop: true
    };
    
  }

    slidePrev() {
    const slides = document.querySelector('ion-slides');
    slides.slidePrev();
  }

  slideNext() {
    const slides = document.querySelector('ion-slides');
    slides.slideNext();
  }

  get getTextIUSlider() {
    return this.languageService.textsIU['slider'];
  }

  getSliderHome(){
    this.contentService.getSlider().then(res => {
      this.images = res
      console.log('___this.images', this.images)
    });
  }

  goTo(slide){
    if(!slide.link) return;
    if(slide.type == "EXTERNAL" || slide.type == "url" || slide.Type == "video"){
      window.open(
        slide.link,
        '_blank'
      );
    } else {
      this.routerService.redirect(slide.link)
    }
  }
}